import React, { useEffect, useState } from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../routing/routes";
import { composePathWithParams } from "../../utils/url";
import Button from "../shared/button/Button";
import { useTranslation } from "react-i18next";
import AddToCalendar from "react-add-to-calendar";
import { Event } from "../../data/interfaces";
import _environment from "../../_environment/_environment";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  event: Event;
}

const EventBox = ({ event, ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to the history instance that you may use to navigate.
  let history = useHistory();

  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // Add to calendar options
  const addToCalendarOptions = {
    config: {
      title: event.name,
      description: event.description,
      startTime: moment.unix(event.start_datetime.seconds).toISOString(),
      endTime: moment.unix(event.end_datetime.seconds).toISOString(),
      location: composePathWithParams(ROUTES.EVENT_DETAIL, [{ id: event.id }], true),
    },
    icon: { " far fa-calendar-plus": "left" },
  };

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  // Event started
  const [isStarted, setIsStarted] = useState<boolean>(false);

  // Event expired
  const [isExpired, setIsExpired] = useState<boolean>(false);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  const join = (): void => {
    history.push(composePathWithParams(ROUTES.EVENT_DETAIL, [{ id: event.id }]));
  };

  const goToStand = (): void => {
    if (!!event.stand && !!event.stand.id) {
      history.push(composePathWithParams(ROUTES.STAND_DETAIL, [{ id: event.stand.id }]));
    }
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    console.log("[EventBox] init");

    setIsExpired(moment.unix(event.end_datetime.seconds).isBefore(moment()));
    setIsStarted(moment.unix(event.start_datetime.seconds).isSameOrBefore(moment()));
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    console.log("[EventBox] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <div
      className={`box event-box clearfix ${isExpired ? "expired" : ""} ${
        isStarted && !isExpired ? "live" : ""
      }`}
    >
      <div className={"content"}>
        {/* Day / Month */}
        <div className={"date"}>
          <div>
            <span>{moment.unix(event.start_datetime.seconds).format("DD")}</span>
            <span>{moment.unix(event.start_datetime.seconds).format("MMM")}</span>
          </div>
        </div>

        {/* Show live indicator */}
        {isStarted && !isExpired && (
          <div className="live-indicator">
            <span></span>
            <small>Live now</small>
          </div>
        )}

        {/* Info */}
        <div className={"info-wrapper"}>
          <h5 className={"name cursor-pointer"} onClick={join}>{event.name}</h5>

          <div className="room">
            {event.congress_room && (
              <>
                <i className={"fas fa-thumbtack"} />
                <span>{event.congress_room}</span>
              </>
            )}
          </div>

          <div className={"time"}>
            <i className={"fas fa-clock"} />
            <span>
              {moment.unix(event.start_datetime.seconds).format("HH:mm")} -{" "}
              {moment.unix(event.end_datetime.seconds).format("HH:mm")}
            </span>
          </div>

          {!!event.relators && !!event.relators.length && (
            <div className={"relators"}>
              <i className={"fas fa-users"} />
              <span>{event.relators.map((r: string) => `${r}`).join(", ")}</span>
            </div>
          )}

          {/* <span className={"description"}>{event.description}</span> */}
        </div>
      </div>
      <div className={"ctas"}>
        <Button onClick={join} className="btn btn-primary btn-user btn-block">
          {!isStarted && !isExpired && t("components.eventBox.details")}
          {isStarted && !isExpired && t("components.eventBox.join")}
          {isExpired && t("components.eventBox.watch_again")}
        </Button>

        {/* Add to calendar */}
        <div className="add-to-calendar">
          {!isStarted && !isExpired && (
            <AddToCalendar
              event={addToCalendarOptions.config}
              buttonTemplate={addToCalendarOptions.icon}
              displayItemIcons={false}
              buttonLabel={t("components.eventBox.addToCalendar")}
            />
          )}
        </div>
      </div>
      <div className={event.stand ? "stand" : "fair"} onClick={event.stand && goToStand}>
        <hr />
        <span className="name">{t("pages.standsList.powered_by")}</span>
        <img
          className={"img-responsive"}
          src={
            event.stand
              ? event.stand.logo_image_url
              : event.image_url
              ? event.image_url
              : _environment.assets.eventPlaceholder
          }
          alt={event.stand ? event.stand.name : ""}
        />
      </div>
    </div>
  );
};
export default EventBox;
